import React from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { IconButton,  Tooltip } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import ModeEditOutlineTwoToneIcon from "@mui/icons-material/ModeEditOutlineTwoTone";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { useTablePagination, useAppMeta } from "hooks";
import HighlightedText from "components/Shared/HighlightedText";
import {
  useLazyListCustomerQuery,
} from "store/services/customerApi";

export const CustomerTab = () => {
  const {id: customerUser} = useParams();
  const [searchParams] = useSearchParams();
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();
  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

 

  

  const columns = [
    {
      name: "Customer ID",
      selector: (row) => row?.customerID,
      cell: (row) => (
        <div title={row?.customerID} className="line-clamp-2">
          <HighlightedText text={row?.customerID} highlight={keyword} />
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      cell: (row) => (
        <div title={row?.phone} className="line-clamp-2">
          {row?.phone}
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      cell: (row) => (
        <div title={row?.email} className="line-clamp-2">
          {row?.email}
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "Address",
      selector: (row) => row?.address,
      cell: (row) => (
        <div title={row?.address} className="line-clamp-2">
          {row?.address}
        </div>
      ),
      minWidth: "200px",
    },
    
    
    
    
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/customerProfile/${row._id}/detail`}>
            <Tooltip title={"View Profile Detail"} arrow>
              <IconButton size="small" aria-label="View Detail">
                <InfoOutlined color="primary" />
              </IconButton>
            </Tooltip>
          </Link>

          <Link to={`/app/crm/customerProfile/${row._id}/edit`}>
            <Tooltip title={"Edit Profile"} arrow>
              <IconButton size="small" aria-label="Edit">
                <ModeEditOutlineTwoToneIcon />
              </IconButton>
            </Tooltip>
          </Link>

        </>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  const [
    fetchCustomers,
    {
      data: customerList,
      isLoading: loadingCustomers,
      isFetching: fetchingCustomers,
    },
  ] = useLazyListCustomerQuery();

  React.useEffect(() => {

    fetchCustomers({
      status: activeTab,
      keywords: keyword,
      page: currentPage,
      limit: perPage,
      customerUser,
      ...(keyword && { keyword }),
    });
  }, [activeTab, fetchCustomers, keyword, currentPage, perPage,customerUser]);

  useAppMeta(`${activeTab} Customers`);

  return (
    <>
      <TableFilter searchLabel="Customer ID/Phone/Email">
        <div className="font-medium">{activeTab} Customers</div>
      </TableFilter>

    
      <AppTable
        columns={columns}
        data={customerList?.data ?? []} 
        paginationServer
        paginationPerPage={perPage}
        paginationDefaultPage={currentPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        progressPending={loadingCustomers || fetchingCustomers}
        paginationTotalRows={customerList?.totalItems ?? 0}
      />
    </>
  );
};
